/* eslint-disable no-undef,no-param-reassign,import/named,consistent-return */
/**
 * Created by chengzhenfu on 2019/5/5.
 * Modified by  on .
 *axios 封装
 */
import Axios from "axios";
import router from "@/router/index";
import { Message,MessageBox } from "element-ui";
import {regettoken,checktoken} from "./api";
import utils from "./utils";

const fetch = Axios.create({
  withCredentials: false,
  baseURL: 'https://admin.henanyanxue.com/',
  timeout: 60000 // 设置超时时间
});
// let loading;
//请求发送前拦截，根据地址重新配置域名，再子路由请求时必须加/ 例如：请求 localhost:80/app/inset  fetch.get('/app/inset');
fetch.interceptors.request.use(
  function(config) {
    let token = localStorage.getItem('token')||''; // 获取token
	let refreshToken = localStorage.getItem('refreshToken')||''
	console.log(config)
    //后期改成从cookies中获取
	 // config.headers = { "X-Access-Token": token || "" };
	 if(config.method=='post'){
	 	config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
	 }
	 if (token) {
	        //加入到请求头
			config.headers['token'] = token
			config.headers['refreshToken']=refreshToken
			config.headers['ispc']='pc'
			console.log(config)
			// config.headers.token =''
			
	    }
		
    // config.headers['token']=token
    // loading = vm.$loading({
    //   lock: true,
    //   text: '努力加载中',
    //   spinner: 'el-icon-loading',
    //   background: 'rgba(0, 0, 0, 0.7)',
    // });
    return config;
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
fetch.interceptors.response.use(
  function(response) {
    // loading.close();
    return response;
  },
  function(error) {
    // 对响应错误做点什么
    //  loading.close();
	console.log(error)
    const { status, data } = error.response;
	
	// if(status==201){
	// 	regettoken().then(res=>{
	// 		localStorage.setItem('token', res.data.data.token)
	// 		localStorage.setItem('refreshToken', res.data.data.refreshToken)
	// 	})
	// }
    switch (status) {
      case 401:
        // window.handleRedirectToLogin()
        // router.push("/");
      //   break;
	  case 318:
			MessageBox.alert(data.msg, '', {
	            confirmButtonText: '确定',
	            callback: action => {
					localStorage.setItem('token', '')
					localStorage.setItem('refreshToken', '')
					 window.location.href = 'http://www.wanjiaxiao.net/';
	            }
	          });
			  return
      default:
        Message(data.msg);
        return Promise.reject(data);
    }
  }
);

export default fetch;
